module.exports = __webpack_public_path__ + "img/steel-plate.55112727.png";